import { IChatMessage } from 'store/messages/messages.state'
import { MiddlewareStore } from 'store/createStore'
import { setAutoTranslateLanguage } from 'store/app/app.actions'
import { DEFAULT_LANGUAGE } from 'translations'

export const handleTranslationLanguage = async (
    message: IChatMessage,
    store: MiddlewareStore,
    session: connect.CustomerChatSession,
) => {
    if (typeof message.content === 'object' || !['MESSAGE', 'EVENT'].includes(message.type)) {
        return message
    }
    const { translation } = store.getState().app

    if (translation?.language) return message

    const { instanceID } = store.getState().app
    const { contactId } = session.getChatDetails()

    try {
        const attributes = await window.bchat.getContactAttributes({
            contactId,
            instanceId: instanceID,
        })

        const customerLang = attributes['sa-customer-language']

        if (customerLang && customerLang !== DEFAULT_LANGUAGE) {
            await window.bchat.toggleAutoTranslate({
                contactId,
                translateMessages: true,
                translationLanguage: customerLang,
            })

            store.dispatch(setAutoTranslateLanguage(customerLang))
        }
    } catch (err) {
        console.error('Failed to retrieve Contact Flow language:', err)
    }

    return message
}
